import React, { ComponentType, FC } from 'react';
import { ObjectTypeEnum, useVersionHistoryContext, VersionHistoryProvider } from '.';

export const VersionHistoryProviderHOC = <P extends object>(Component: ComponentType<P>): FC<P> => {
    const WrappedComponent: FC<P> = (props) => {
        const { selectedObjectDetails } = useVersionHistoryContext();

        if (selectedObjectDetails?.objectTypeId === ObjectTypeEnum.Workflow) {
            return <Component {...props} />;
        }

        return (
            <VersionHistoryProvider>
                <Component {...props} />
            </VersionHistoryProvider>
        );
    };

    WrappedComponent.displayName = `VersionHistoryProviderHOC(${
        Component.displayName || Component.name || 'Component'
    })`;
    return WrappedComponent;
};
